module.exports = __webpack_public_path__ + "static/media/435_Front.fe943427.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/435_Front.jpg
// module id = 104
// module chunks = 0